import { FLIGHTDECK_BASE_URL } from '@/utils/flightdeck';

/**
 * Zendesk custom ticket field ID for AI Assistant transfer URL
 */
export const ZENDESK_AI_ASSISTANT_URL_FIELD_ID = '38044299583639';

/**
 * Zendesk custom ticket field ID for Handover message
 */
export const ZENDESK_HANDOVER_MESSAGE_FIELD_ID = '38586031995287';

/**
 * Builds a Flightdeck conversation URL from a transfer/session ID
 */
export function buildFlightdeckConversationUrl(sessionId: string): string {
  return `${FLIGHTDECK_BASE_URL}/ai-assistant/${sessionId}/conversation`;
}
